import React from 'react';

import { Button } from '@flywire/headlessui-tailwindcss';

import { Heading } from 'components/Heading/Heading';
import { Modal } from 'components/ui/Modal/Modal';
import { ENTER, SPACE } from 'constants/index';
import { useTranslations } from 'utils';

type DuplicatedTaxPaymentModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
};

const DuplicatedTaxPaymentModal = ({
  isOpen = false,
  onClose,
}: DuplicatedTaxPaymentModalProps) => {
  const i18n = useTranslations();

  return (
    <Modal size="medium" isOpen={isOpen} className="TaxModal" onClose={onClose}>
      <Heading as="h3" size="large">
        {i18n.t('duplicatedTaxPaymentModal.title')}
      </Heading>
      <p className="type-regular">{i18n.t('duplicatedTaxPaymentModal.text')}</p>
      <footer>
        <Button
          tone="primary"
          data-testid="confirmButton"
          onMouseDown={onClose}
          onKeyDown={evt => [ENTER, SPACE].includes(evt.keyCode) && onClose?.()}
        >
          {i18n.t('modal.button.accept')}
        </Button>
      </footer>
    </Modal>
  );
};

export { DuplicatedTaxPaymentModal };
